import { getPlayerCommandList } from "./playerCommandsMapping";

export const speechCommandsFR = {
    player: getPlayerCommandList('fr')
}